var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79766 19.6506L3.99766 17.8187H14.5977C16.3977 17.8187 17.7977 16.394 17.7977 14.5621V12.3232V12.1196H17.3977H16.3977H15.9977V12.3232V14.7656C15.9977 15.5798 15.3977 16.1904 14.5977 16.1904H3.99766L5.79766 14.3586L5.99766 14.155L5.79766 13.9515L4.99766 13.1373L4.79766 12.9338L4.59766 13.1373L1.39766 16.394C0.997656 16.801 0.997656 17.2081 1.39766 17.6152L4.59766 20.8718L4.79766 21.0754L4.99766 20.8718L5.79766 20.0577V19.6506Z",
    fill: "#3B74FA",
    stroke: "#3B74FA",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.34958L14.8 4.18144H4.2C2.4 4.18144 1 5.60622 1 7.43808V9.88056V10.0841H1.4H2.6H2.8V9.67702V7.43808C2.8 6.62392 3.4 5.80976 4.2 5.80976H14.8L13 7.84516L12.8 8.0487L13 8.25224L13.8 9.0664L14 9.26994L14.2 9.0664L17.4 5.60622C17.8 5.19914 17.8 4.79206 17.4 4.38498L14.2 1.12834L14 0.924805L13.8 1.12834L13 1.9425V2.34958Z",
    fill: "#3B74FA",
    stroke: "#3B74FA",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.89dd05e4dee39c17f1678fd70748f62d.svg";
export { ForwardRef as ReactComponent };